import { Link } from 'react-router';

import { Anchor, Badge, Indicator, Tooltip } from '@mantine/core';
import { PROGRESS_COMPLETE_PERCENTAGE } from 'constants/locationGoLive';
import { BADGE_VARIANTS } from 'constants/mantineVariants';
import { useAuth } from 'hooks/useAuth';
import { getRestaurantPath, PROGRESS } from 'scopes/nav';
import { WarningIconSm } from '@chownow/pantry/icons';

interface RestaurantProgressType {
  compact?: boolean;
  link?: boolean;
  location?: {
    id?: string;
    go_live_requirements_progress?: number;
  };
}

export default function RestaurantProgress({ compact, link, location }: RestaurantProgressType) {
  const { isUserCubohOnly } = useAuth();

  if (
    location?.go_live_requirements_progress === undefined ||
    location.go_live_requirements_progress === PROGRESS_COMPLETE_PERCENTAGE
  ) {
    return null;
  }

  const baseLabel = `${location.go_live_requirements_progress}%`;
  const linkToProgress = link
    ? `${getRestaurantPath(isUserCubohOnly, location.id)}/${PROGRESS}`
    : '';

  if (compact) {
    const indicator = (
      <Indicator
        color="var(--surface-caution)"
        variant="caution"
        data-testid="RestaurantProgress"
        label={baseLabel}
      />
    );
    if (!link) return indicator;
    return (
      <Anchor component={Link} to={linkToProgress} underline="never">
        {indicator}
      </Anchor>
    );
  }

  const badge = (
    <Badge
      size="xs"
      leftSection={<WarningIconSm />}
      variant={BADGE_VARIANTS.caution}
      data-testid="RestaurantProgress"
    >
      {baseLabel} Done
    </Badge>
  );

  return (
    <Tooltip
      label="You are currently not live. Click to see your requirements to go live."
      position="bottom"
    >
      {link ? (
        <Anchor component={Link} to={linkToProgress} underline="never">
          {badge}
        </Anchor>
      ) : (
        badge
      )}
    </Tooltip>
  );
}
